import React, { useState, useEffect } from 'react';
import { AlignLeft, User, Wand2 } from 'lucide-react';
import { FlowingSphere } from '@/components/FlowingSphere';

const QUICK_SKILLS = [
  { id: 'continue', label: '接下来补哪里', icon: AlignLeft },
  { id: 'character', label: '人物怎么站', icon: User },
  { id: 'smooth', label: '先顺一顺', icon: Wand2 },
];

export const WelcomeScreen: React.FC<{ onSkillClick: (label: string) => void }> = ({ onSkillClick }) => {
  const [sphereFlowing, setSphereFlowing] = useState(false);
  const [displayedText, setDisplayedText] = useState('');
  const [showCursor, setShowCursor] = useState(true);
  const fullText = '今天一起创作点什么？';

  useEffect(() => {
    let cancelled = false;
    const runLoop = async () => {
      while (!cancelled) {
        setSphereFlowing(true);
        setDisplayedText('');
        setShowCursor(true);
        for (let i = 0; i <= fullText.length; i++) {
          if (cancelled) return;
          setDisplayedText(fullText.slice(0, i));
          await new Promise(r => setTimeout(r, 80));
        }
        setSphereFlowing(false);
        await new Promise(r => setTimeout(r, 4000));
        if (cancelled) return;
        setSphereFlowing(true);
        for (let i = fullText.length; i >= 0; i--) {
          if (cancelled) return;
          setDisplayedText(fullText.slice(0, i));
          await new Promise(r => setTimeout(r, 40));
        }
        setShowCursor(false);
        await new Promise(r => setTimeout(r, 1500));
      }
    };
    runLoop();
    return () => { cancelled = true; };
  }, []);

  return (
    <div className="flex-1 flex flex-col justify-end pb-6">
      <div className="flex items-center gap-2 mb-2">
        <FlowingSphere size={16} isFlowing={sphereFlowing} />
        <span className="text-[13px] text-slate-300">Hi Bong Friend!</span>
      </div>
      <h2 className="text-[22px] font-semibold text-white mb-5 h-[32px]">
        {displayedText}
        {showCursor && <span className="inline-block w-[2px] h-[22px] bg-white ml-0.5 align-middle cursor-blink" />}
      </h2>
      <div className="flex items-center gap-2">
        {QUICK_SKILLS.map((skill) => (
          <button
            key={skill.id}
            onClick={() => onSkillClick(skill.label)}
            className="flex items-center gap-1.5 px-3 py-2 rounded-lg bg-[#1c1c1e] border border-white/10 text-[12px] text-slate-300 hover:bg-[#252528] hover:border-white/15 transition-all"
          >
            <skill.icon size={12} className="text-slate-400" />
            <span>{skill.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
